import { useContext, useEffect, useState } from "react";

import { SearchTvSeriesAssetsRequest } from "../../../../common/api/master-api/assets/search/tv-series-requests-responses/SearchTvSeriesAssetsRequest";
import { SearchTvSeriesAssetsResponse } from "../../../../common/api/master-api/assets/search/tv-series-requests-responses/SearchTvSeriesAssetsResponse";
import { useAssetsApi } from "../../../../common/api/master-api/assets/useAssetsApi";
import { AssetItem, mapToAssetsListItem } from "../../common/AssetItem";
import { SingleTvSeriesContext } from "../context/SingleTvSeriesContext";
import { TvSeriesAssetsListUrlFilters } from "./useTvSeriesAssetsListUrlFilters";

interface UseTvSeriesAssetsProps {
    filters?: TvSeriesAssetsListUrlFilters;
}

export const useTvSeriesAssets = (props: UseTvSeriesAssetsProps) => {
    const { tvSeries } = useContext(SingleTvSeriesContext);

    const { filters } = props;

    const { searchTvSeries } = useAssetsApi();

    const [items, setItems] = useState<AssetItem[]>([]);
    const [totalItems, setTotalItems] = useState<number>(0);

    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        if (tvSeries && filters) {
            setIsLoading(true);

            const request: SearchTvSeriesAssetsRequest = {
                tvSeriesId: tvSeries.id,
                seasonId: filters.season,
                episodeId: filters.episode,
                distributorIds: filters.distributors,
                versionTypeIds: filters.versionTypes,
                brandingIds: filters.brandings,
                statusIds: filters.statuses,
                page: filters.page,
                pageSize: filters.pageSize,
                sortBy: filters.sortBy,
                sortOrder: filters.sortOrder,
                types: filters.types,
                origins: filters.origins,
                recordTypes: filters.recordTypes,
                createdDateFrom: filters.createdDateFrom?.toISOString(),
                createdDateTo: filters.createdDateTo?.toISOString(),
                updatedDateFrom: filters.updatedDateFrom?.toISOString(),
                updatedDateTo: filters.updatedDateTo?.toISOString(),
                trailers: filters.trailers
            };

            searchTvSeries(request).then((response: SearchTvSeriesAssetsResponse) => {
                const newItems = response.items.map(mapToAssetsListItem);

                setItems(newItems);
                setTotalItems(response.totalCount);

                setIsLoading(false);
            });
        }
    }, [tvSeries, filters]);

    return {
        items,
        totalItems,
        isLoading
    };
};
